module.exports = __webpack_public_path__ + "media/img/corporate/hero-1cfbe1b33f4eb0b1ca2ebd5addfeb357.png";